export default __webpack_public_path__ + "static/media/BSS-Brochure.a98e548c.pdf";